/* Home catalog pagination — PAGE_SIZE 10, optional ?page=N */
(function (global) {
    'use strict';

    var DEFAULT_PAGE_SIZE = 10;

    function toPositiveInt(value, fallback) {
        var parsed = parseInt(value, 10);
        if (!isFinite(parsed) || parsed < 1) {
            return fallback;
        }
        return parsed;
    }

    function resolveCatalogPage(total, pageSize, requestedPage) {
        var size = Math.max(1, toPositiveInt(pageSize, DEFAULT_PAGE_SIZE));
        var count = Math.max(0, toPositiveInt(total, 0));
        var pageCount = Math.max(1, Math.ceil(count / size) || 1);
        var page = Math.min(pageCount, Math.max(1, toPositiveInt(requestedPage, 1)));

        return {
            page: page,
            pageSize: size,
            pageCount: pageCount,
            start: count === 0 ? 0 : (page - 1) * size,
            end: Math.min(count, page * size),
            showPagination: count > size
        };
    }

    function readQueryInt(searchParams, key) {
        if (!searchParams || !searchParams.get(key)) {
            return null;
        }
        return toPositiveInt(searchParams.get(key), null);
    }

    function buildPageHref(page, pageSize, defaultPageSize) {
        var params = new URLSearchParams(global.location ? global.location.search : '');
        if (page <= 1) {
            params.delete('page');
        } else {
            params.set('page', String(page));
        }
        if (pageSize && pageSize !== defaultPageSize) {
            params.set('pageSize', String(pageSize));
        } else {
            params.delete('pageSize');
        }
        var query = params.toString();
        var path = global.location ? global.location.pathname : '/';
        return query ? path + '?' + query : path;
    }

    global.MeloHomeCatalog = {
        DEFAULT_PAGE_SIZE: DEFAULT_PAGE_SIZE,
        resolveCatalogPage: resolveCatalogPage,
        buildPageHref: buildPageHref
    };

    if (typeof document === 'undefined') {
        return;
    }

    var root = document.querySelector('[data-melo-home-catalog]');
    if (!root) {
        return;
    }

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-melo-catalog-item]'));
    var pagination = root.querySelector('[data-melo-catalog-pagination]');
    var pagesHost = root.querySelector('[data-melo-catalog-pages]');
    var prevLink = root.querySelector('[data-melo-catalog-prev]');
    var nextLink = root.querySelector('[data-melo-catalog-next]');
    var configuredSize = toPositiveInt(root.getAttribute('data-page-size'), DEFAULT_PAGE_SIZE);

    function currentParams() {
        return new URLSearchParams(window.location.search);
    }

    function currentPageSize() {
        var fromQuery = readQueryInt(currentParams(), 'pageSize');
        return fromQuery || configuredSize;
    }

    function applyPage(requestedPage, options) {
        var state = resolveCatalogPage(items.length, currentPageSize(), requestedPage);
        var opts = options || {};

        items.forEach(function (item, index) {
            var visible = index >= state.start && index < state.end;
            item.hidden = !visible;
        });

        if (!pagination) {
            return state;
        }

        if (!state.showPagination) {
            pagination.hidden = true;
            return state;
        }

        pagination.hidden = false;

        if (prevLink) {
            prevLink.href = buildPageHref(Math.max(1, state.page - 1), state.pageSize, configuredSize);
            prevLink.setAttribute('aria-disabled', state.page <= 1 ? 'true' : 'false');
            prevLink.classList.toggle('is-disabled', state.page <= 1);
        }

        if (nextLink) {
            nextLink.href = buildPageHref(Math.min(state.pageCount, state.page + 1), state.pageSize, configuredSize);
            nextLink.setAttribute('aria-disabled', state.page >= state.pageCount ? 'true' : 'false');
            nextLink.classList.toggle('is-disabled', state.page >= state.pageCount);
        }

        if (pagesHost) {
            pagesHost.innerHTML = '';
            for (var i = 1; i <= state.pageCount; i += 1) {
                var link = document.createElement('a');
                link.className = 'melo-home-catalog-page-num' + (i === state.page ? ' is-current' : '');
                link.href = buildPageHref(i, state.pageSize, configuredSize);
                link.textContent = String(i);
                if (i === state.page) {
                    link.setAttribute('aria-current', 'page');
                }
                pagesHost.appendChild(link);
            }
        }

        if (opts.updateUrl && window.history && window.history.replaceState) {
            window.history.replaceState({}, '', buildPageHref(state.page, state.pageSize, configuredSize));
        }

        return state;
    }

    function pageFromLocation() {
        return readQueryInt(currentParams(), 'page') || 1;
    }

    function onPaginationClick(event) {
        var link = event.target.closest('a');
        if (!link || !pagination.contains(link) || link.getAttribute('aria-disabled') === 'true') {
            return;
        }
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }
        event.preventDefault();
        var url;
        try {
            url = new URL(link.href, window.location.origin);
        } catch (err) {
            return;
        }
        var nextPage = readQueryInt(url.searchParams, 'page') || 1;
        applyPage(nextPage, { updateUrl: true });
    }

    applyPage(pageFromLocation(), { updateUrl: true });

    if (pagination) {
        pagination.addEventListener('click', onPaginationClick);
    }

    window.addEventListener('popstate', function () {
        applyPage(pageFromLocation());
    });
})(typeof window !== 'undefined' ? window : global);
